export const TYPE_DICT = {
  INCOMING: 31,
  OUTGOING: 32,
};
